import { Route } from '@angular/router';
import { CustomerLayout } from '../pages/customer/customer.layout';

export const customerRoutes: Route[] = [
  {
    path: 'customer',
    component: CustomerLayout,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'notice',
      },
      {
        path: 'notice',
        children: [
          {
            path: '',
            loadComponent: () => import('../pages/customer/notice/notice.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                '../pages/customer/notice/detail-notice/detail-notice.page'
              ),
          },
        ],
      },
      {
        path: 'inquiry',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../pages/customer/inquiry/inquiry.page'),
          },
          {
            path: 'form',
            loadComponent: () =>
              import(
                '../pages/customer/inquiry/create-inquiry/create-inquiry.page'
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                '../pages/customer/inquiry/detail-inquiry/detail-inquiry.page'
              ),
          },
        ],
      },
      {
        path: 'faq',
        loadComponent: () => import('../pages/customer/faq/faq.page'),
      },
    ],
  },
];
